import * as Yup from 'yup'
export const ipRegex = /\b((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|[1-9]?[0-9])\b/;

export const MACHINENAME = {
  label: "Machine Name",
  validation: {
    required: "Machine name is required",
  },
};

export const PORT = {
  label: "Port",
  validation: {
    required: "Port is required",
  },
};

export const IPADDRESS = {
  label: "IP Address",
  validation: {
    required: "IP Address is required",
    valid: "Please enter a valid IP Address.",
  },
};

export const AETITLE = {
  label: "AE Title",
  validation: {
    required: "AE Title is required",
  },
};

export const MACHINETYPE = {
  label: "Machine Type",
  validation: {
    required: "Machine Type is required",
  },
};


export const MachinesFormSchema=Yup.object().shape({
  aeTitle: Yup.string().required(AETITLE.validation.required),
  machineType : Yup.string().required(MACHINETYPE.validation.required),
  machineName:Yup.string().required(MACHINENAME.validation.required),
  ipAddress:Yup.string()
  .matches(ipRegex, IPADDRESS.validation.valid)
  .required(IPADDRESS.validation.required),
  port: Yup.string()
  // @ts-ignore
  .test('is-number', 'Port number must be a number', value => !isNaN(value))
  .test('valid-range', 'Port number must be between 1 and 65535', value => {
    const port = parseInt(value, 10);
    return port >= 1 && port <= 65535;
  })
  .required(PORT.validation.required)
})
